<template>
  <div class="rec-card-content">
    <slot name="default" />
  </div>
</template>

<style scoped lang="scss">
.rec-card-content {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
</style>
